import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { logger } from '@parrot-software/observability';

import { useAuth } from 'providers/root/AuthProvider';

import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import SignInLayout from 'components/SignInLayout';

import { ParrotLogo } from '@experimental-components/IconsComponents/ParrotLogo';

import {
  removeAuthToken,
  removeCookieUser,
  removeOrganizationUser,
  removeStoreBackupKey,
  removeStoreDratfKey,
  removeUserCurrentStore,
  removeUserStoresStoreKey,
} from 'utils/auth';
import { clearMenuScopeLocalStorage, removeBrandSelectedLocalStorage } from 'utils/menuMaker';
import useFiltersReports from 'hooks/useFiltersReports';

import useStyles from './styles';

const iamLog = logger.forDomain('IAM');

export function LoggedOutPage({ t }) {
  const classes = useStyles();
  const history = useHistory();

  const { clearLicenseStateChannel } = useAuth();
  const { removeFilters } = useFiltersReports();

  // The page clears the session itself instead of trusting whoever pushed here to have done it. The
  // callers that already clear it stay correct: every remove is idempotent.
  useEffect(() => {
    iamLog.warn('Session expired', { 'page.url': window.location.pathname });
    logger.clearGlobalContext();
    removeAuthToken();
    removeUserStoresStoreKey();
    removeUserCurrentStore();
    removeStoreDratfKey();
    removeStoreBackupKey();
    removeBrandSelectedLocalStorage();
    removeOrganizationUser();
    removeCookieUser();
    clearMenuScopeLocalStorage();
    clearLicenseStateChannel();
    removeFilters();
  }, []);

  function handleSignIn() {
    history.push('/signin');
  }

  return (
    <SignInLayout>
      <div className={classes.header}>
        <ParrotLogo className="h-16" />
      </div>

      <Box mb={2} mt={4}>
        <Typography gutterBottom variant="h6">
          {t('signIn:loggedOut.heading')}
        </Typography>
      </Box>

      <Box mb={2} width="80%">
        <Typography align="center" color="textSecondary" variant="subtitle1">
          {t('signIn:loggedOut.message')}
        </Typography>
      </Box>

      <Button color="primary" onClick={handleSignIn} size="large" variant="contained">
        {t('signIn:buttons.signIn')}
      </Button>
    </SignInLayout>
  );
}

LoggedOutPage.propTypes = {
  t: PropTypes.func,
};

export default withTranslation('signIn')(LoggedOutPage);
